import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=a519af70&"
import script from "./Fieldset.vue?vue&type=script&lang=js&"
export * from "./Fieldset.vue?vue&type=script&lang=js&"
import style0 from "veui-theme-dls/components/fieldset.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports